<div class="max-w-480 mx-auto px-4 overflow-y-hidden">

  <!-- Alert: Limit dokumentów przekroczony -->
  <div *ngIf="isDocumentLimitExceeded && mode === 'create'" 
       class="mt-6 relative overflow-hidden rounded-2xl bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 p-4 shadow-lg">
    
    <!-- Dekoracja tła -->
    <div class="absolute inset-0 overflow-hidden">
      <div class="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-2xl"></div>
      <div class="absolute -bottom-10 -left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
    </div>
    
    <div class="relative z-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div class="flex items-start gap-3">
        <div class="flex-shrink-0 w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
          <mat-icon [svgIcon]="'tabler_outline:alert-triangle'" class="text-white"></mat-icon>
        </div>
        <div>
          <h4 class="font-bold text-white text-lg">Limit dokumentów przekroczony</h4>
          <p class="text-white/90 text-sm mt-0.5">
            Wykorzystałeś limit dostępny w Twoim abonamencie. Zwiększ plan, aby wystawić więcej dokumentów.
          </p>
        </div>
      </div>
      
      <a routerLink="/konto/subskrypcje"
         class="flex-shrink-0 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-orange-600 font-bold rounded-xl 
                hover:bg-orange-50 transition-colors shadow-md hover:shadow-lg">
        <mat-icon [svgIcon]="'tabler_outline:crown'" class="!w-5 !h-5"></mat-icon>
        <span>Zmień plan</span>
      </a>
    </div>
  </div>

  <!-- Header and buttons -->
  <div class="grid grid-cols-1 md:grid-cols-3 w-full mt-6">

    <div>
      <div class="text-3xl font-medium pl-4">{{invoice._id != null ? 'Edycja dokumentu' : 'Nowy dokument'}}</div>
    </div>

    <div class="md:col-span-2 ml-auto flex space-x-2 mb-4 items-end">

      <button [disabled]="processing == true || !isInvoiceNameAvailable" color="primary" mat-flat-button *ngIf="!invoice || !invoice._id"
        (click)="createDocument()" data-tour-id="utworz-dokument">
        <mat-icon *ngIf="processing" class="animate-spin" [svgIcon]="'tabler_outline:loader-2'"></mat-icon>
        <mat-icon *ngIf="!processing" [svgIcon]="'tabler_outline:plus'"></mat-icon>
        <span class="ml-2">Utwórz dokument</span>
      </button>

      <button [disabled]="processing == true || !isInvoiceNameAvailable" color="primary" mat-flat-button *ngIf="invoice && invoice._id"
        (click)="updateDocument()">
        <mat-icon *ngIf="processing" class="animate-spin" [svgIcon]="'tabler_outline:loader-2'"></mat-icon>
        <mat-icon *ngIf="!processing" [svgIcon]="'tabler_outline:check'"></mat-icon>
        <span class="ml-2">Zapisz dokument</span>
      </button>

      <button [matMenuTriggerFor]="menu" mat-stroked-button data-tour-id="dostosuj">
        <mat-icon [svgIcon]="'tabler_outline:tool'"></mat-icon>
        <span class="ml-2">Dostosuj</span>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="showUpdateSellerDialog()">
          <mat-icon [svgIcon]="'tabler_outline:pencil'"></mat-icon>
          Edytuj dane sprzedawcy
        </button>
        <button mat-menu-item (click)="showToggleFormFieldsDialog()">
          <mat-icon [svgIcon]="'tabler_outline:settings'"></mat-icon>
          Dostosuj dokument
        </button>
      </mat-menu>

      <button color="primary" mat-stroked-button *ngIf="invoice && invoice._id"
        [routerLink]="'/konto/dokumenty/'+invoice._id+'/podglad'" [matTooltip]="'Powrót do widoku opcji'">
        <mat-icon [svgIcon]="'tabler_outline:arrow-right'"></mat-icon>
        <span class="ml-2"> Wróć do opcji</span>
      </button>

      <button class="lg:hidden !w-9 !h-9 bg-gray-200 dark:bg-slate-700" color="primary" mat-icon-button (click)="togglePreview()"
        [matTooltip]="'Podgląd'">
        <mat-icon class="icon-size-5" [svgIcon]="'tabler_outline:external-link'"></mat-icon>
      </button>

    </div>
  </div>

  <!-- Form and preview -->
  <div class="relative grid grid-cols-1 lg:grid-cols-12 gap-x-4">

    <!-- Form -->
    <div class="relative bg-card col-span-12 lg:col-span-8 xl:col-span-7 w-full p-4 rounded-xl">

      <div class="grid grid-cols-1 md:grid-cols-2">



        <!-- Left form side -->
        <div>
          <div class="controls-container bg-neutral-100 dark:bg-slate-900 grid grid-cols-4 gap-2">

            <div class="col-span-4" data-tour-id="typ-dokumentu">
              <mat-form-field class="w-full" subscriptSizing="dynamic"
                [matTooltip]="mode == 'edit' ? 'Nie można zmienić typu edytowanego dokumentu.' : ''">
                <mat-label>Typ dokumentu</mat-label>
                <mat-select [disabled]="mode == 'edit' ? true : false" [value]="invoice.documentType"
                  (valueChange)="switchDocument($event)">
                  <mat-option [value]="documentType.id"
                    *ngFor="let documentType of availableDocs">
                    <span class="flex items-center gap-2">
                      {{ documentType.name }}
                      <mat-icon *ngIf="documentType.ksefSupported" 
                                class="icon-size-4" 
                                [svgIcon]="'ksef:ksef-logo'"
                                matTooltip="Można wysłać do KSeF"></mat-icon>
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Ostrzeżenie: typ "Faktura" nie jest obsługiwany przez KSeF -->
            <div class="col-span-4" *ngIf="invoice.documentType === 'Faktura'">
              <!-- Wersja pełna -->
              <div *ngIf="!isFakturaKsefWarningCollapsed"
                class="relative rounded-lg bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800/50 px-3 py-2.5"
                style="max-width: 600px;">
                <button type="button" (click)="toggleFakturaKsefWarning()" matTooltip="Ukryj"
                  class="absolute top-1.5 right-1.5 text-blue-500/60 dark:text-blue-300/60 hover:text-blue-700 dark:hover:text-blue-100 p-0.5 rounded transition-colors">
                  <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:x'"></mat-icon>
                </button>
                <div class="flex items-start gap-2 pr-6">
                  <mat-icon class="icon-size-4 flex-shrink-0 mt-0.5 text-blue-600 dark:text-blue-300"
                    [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
                  <div class="text-blue-900 dark:text-blue-100 text-xs leading-snug">
                    <div class="font-medium">Ten typ dokumentu nie zostanie wysłany do KSeF.</div>
                    <p class="mt-1 text-blue-800/85 dark:text-blue-200/85">
                      Jeżeli planujesz wysłać ten dokument do KSeF, wybierz typ
                      <strong>Faktura VAT</strong> — to odpowiednik faktury podstawowej w KSeF.
                      KSeF nie rozróżnia faktur „z VAT" i „bez VAT", zwolnienie z VAT dodaje się jako adnotację.
                    </p>
                    <p class="mt-1 text-blue-700/70 dark:text-blue-300/70 italic">
                      Nazewnictwo typów dokumentów zostanie ujednolicone od 1 stycznia 2027 roku.
                    </p>
                  </div>
                </div>
              </div>
              <!-- Wersja zwinięta -->
              <button *ngIf="isFakturaKsefWarningCollapsed" type="button" (click)="toggleFakturaKsefWarning()"
                class="w-full flex items-center gap-2 px-3 py-1.5 rounded-lg bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800/50 text-blue-800 dark:text-blue-200 hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors text-xs"
                style="max-width: 600px;">
                <mat-icon class="icon-size-4 text-blue-600 dark:text-blue-300" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
                <span class="flex-1 text-left">Ten typ nie zostanie wysłany do KSeF — pokaż szczegóły</span>
                <mat-icon class="icon-size-4 text-blue-600 dark:text-blue-300" [svgIcon]="'tabler_outline:chevron-down'"></mat-icon>
              </button>
            </div>

            <div class="col-span-4" *ngIf="document.config.hasMarginProcedure">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Oznaczenie marży</mat-label>
                <mat-select [value]="invoice.marginProcedureId" (valueChange)="setMarginProcedure($event)">
                  <mat-option [value]="procedure.id"
                    *ngFor="let procedure of marginProcedures">{{procedure.text}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            
            <ng-container *ngIf="formatInfo != null && invoice.numberingFormat != null">
              <div class="col-span-1">
                <mat-form-field class="fakturnia-mat-dense w-full" [subscriptSizing]="'dynamic'">
                  <mat-label>Symbol</mat-label>
                  <input matInput [value]="invoice.symbol" (change)="updateSymbol($event.target.value)" type="text"
                    class="text-right" />
                </mat-form-field>
              </div>
              <div class="col-span-3">
                <mat-form-field class="fakturnia-mat-dense w-full" [subscriptSizing]="'dynamic'">
                  <mat-label>
                    Numer dokumentu*
                  </mat-label>
                  <input matInput integerOnly [integerOnlyMinValue]="1" [value]="invoice.documentNo"
                    (change)="updateDocumentNo($event.target.value);" type="text"
                    [class]="formatInfo?.type === 'PREFIX' ? 'text-right' : 'text-left'" />
                  <span *ngIf="formatInfo && formatInfo.type === 'PREFIX'" matSuffix>{{invoice.formattedDateNumber}}</span>
                  <span *ngIf="formatInfo && formatInfo.type === 'SUFFIX'" matPrefix>{{invoice.formattedDateNumber}}</span>
                  <button *ngIf="mode === 'create'" mat-icon-button matIconSuffix [matTooltip]="'Zmień format numeracji'"
                    (click)="showNumberingFormatDialog()">
                    <mat-icon [svgIcon]="'tabler_outline:settings'"></mat-icon>
                  </button>
                  <mat-hint *ngIf="!isInvoiceNameAvailable">Faktura o tym numerze już istnieje</mat-hint>
                </mat-form-field>
              </div>
            </ng-container>

          </div>

          <!-- Kontrahent - Nabywca (normalnie) lub Sprzedawca (przy samofakturowaniu) -->
          <div class="mt-3 controls-container bg-neutral-100 dark:bg-slate-900 grid grid-cols-1 gap-y-2">

            <!-- Tryb normalny: Nabywca = kontrahent do wyboru -->
            <ng-container *ngIf="!isSelfInvoicingMode">
              <select-client-control data-tour-id="nabywca" label="Nabywca"
                (onEditClick)="showCreateOrUpdateClientDialog(invoice.buyer, 'buyer')" [value]="invoice.buyer.type === 'person' ? ((invoice.buyer.firstName || '') + ' ' + (invoice.buyer.lastName || '')).trim() : invoice.buyer.name"
                (onClientSelect)="updateBuyer($event)">
              </select-client-control>

              <div *ngIf="(invoice.buyer._id == null || invoice.buyer._id == '')" class="mt-1 ms-2 error-text">
                Wybierz nabywcę
              </div>

              <div *ngIf="invoice.buyer._id && isAddressIncomplete(invoice.buyer)" 
                class="mt-2 p-2 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800">
                <div class="text-sm text-orange-700 dark:text-orange-300 flex items-center">
                  <mat-icon class="icon-size-4 mr-2" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                  Brakuje danych adresowych nabywcy (ulica, kod pocztowy lub miejscowość). Zaktualizuj dane kontrahenta.
                </div>
              </div>

              <div *ngIf="invoice.buyer._id && invoice.buyer.identifierType === 'idWew'" 
                class="mt-2 p-2 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                <div class="text-sm text-red-700 dark:text-red-300 flex items-center">
                  <mat-icon class="icon-size-4 mr-2" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                  Wybrany nabywca ma typ identyfikatora „IDWew", który jest dozwolony tylko dla odbiorcy. KSeF nie zaakceptuje tej faktury. Zmień typ identyfikatora nabywcy lub przenieś go do pola Odbiorca.
                </div>
              </div>

              <div *ngIf="invoice.buyer._id && invoice.buyer.identifierType === 'nip' && !invoice.buyer.nip"
                class="mt-2 p-2 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800">
                <div class="text-sm text-orange-700 dark:text-orange-300 flex items-center">
                  <mat-icon class="icon-size-4 mr-2 text-amber-600 dark:text-amber-400" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                  Nabywca ma wybrany typ identyfikatora „NIP", ale numer NIP nie został wprowadzony. Uzupełnij dane kontrahenta.
                </div>
                
              </div>
            </ng-container>

            <!-- Tryb samofakturowania: Sprzedawca = kontrahent do wyboru -->
            <ng-container *ngIf="isSelfInvoicingMode">
              <div class="mb-2 p-2 rounded-lg bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800">
                <div class="text-sm text-blue-600 dark:text-blue-400 flex items-center">
                  <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
                  Tryb samofakturowania: wystawiasz fakturę w imieniu sprzedawcy
                </div>
              </div>
              
              <select-client-control label="Sprzedawca (kontrahent)"
                (onEditClick)="showCreateOrUpdateClientDialog(invoice.seller, 'seller')" [value]="invoice.seller.name"
                (onClientSelect)="updateSeller($event)">
              </select-client-control>

              <div *ngIf="(invoice.seller._id == null || invoice.seller._id == '')" class="mt-1 ms-2 error-text">
                Wybierz sprzedawcę
              </div>
              
              <!-- Nabywca (Ty) - tylko do podglądu -->
              <div class="mt-3 p-3 rounded-lg bg-gray-100 dark:bg-gray-800">
                <div class="text-sm text-gray-500 dark:text-gray-400 mb-1">Nabywca (Ty)</div>
                <div class="font-medium">{{ invoice.buyer.name }}</div>
                <div class="text-sm text-gray-600 dark:text-gray-400" *ngIf="invoice.buyer.nip">NIP: {{ invoice.buyer.nip }}</div>
              </div>
            </ng-container>

            <!-- JST checkbox - widoczny gdy ustawienie enableJst jest włączone -->
            <div *ngIf="enableJst" class="mt-3">
              <mat-checkbox 
                color="primary"
                [checked]="invoice.ksefJst"
                (change)="toggleKsefJst($event.checked)">
                Czy faktura dotyczy jednostki podrzędnej JST?
              </mat-checkbox>
            </div>

            <!-- Toggle receiver visibility button -->
            <button mat-button class="text-primary text-sm mt-3 flex items-center" 
                    (click)="toggleReceiverVisibility()"
                    [disabled]="invoice.ksefJst && invoice.hasReceiver">
              <span>{{invoice.hasReceiver ? 'Ukryj odbiorcę' : 'Dodaj odbiorcę'}}</span>
            </button>

            <ng-container *ngIf="invoice.hasReceiver">
              <select-client-control label="Odbiorca"
                (onEditClick)="showCreateOrUpdateClientDialog( invoice.receiver, 'receiver')"
                [value]="invoice.receiver.type === 'person' ? ((invoice.receiver.firstName || '') + ' ' + (invoice.receiver.lastName || '')).trim() : invoice.receiver.name" (onClientSelect)="updateReceiver($event)">
              </select-client-control>

              <div *ngIf="(invoice.receiver._id == null || invoice.receiver._id == '')" class="mt-1 ms-2 error-text">
                Wybierz odbiorcę
              </div>

              <div *ngIf="invoice.receiver._id && isAddressIncomplete(invoice.receiver)" 
                class="mt-2 p-2 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800">
                <div class="text-sm text-orange-700 dark:text-orange-300 flex items-center">
                  <mat-icon class="icon-size-4 mr-2" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                  Brakuje danych adresowych odbiorcy (ulica, kod pocztowy lub miejscowość). Zaktualizuj dane kontrahenta.
                </div>
              </div>

              <div *ngIf="invoice.receiver._id && invoice.receiver.identifierType === 'nip' && !invoice.receiver.nip"
                class="mt-2 p-2 rounded-lg bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800">
                <div class="text-sm text-orange-700 dark:text-orange-300 flex items-center">
                  <mat-icon class="icon-size-4 mr-2 text-amber-600 dark:text-amber-400" [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                  Odbiorca ma wybrany typ identyfikatora „NIP", ale numer NIP nie został wprowadzony. Uzupełnij dane kontrahenta.
                </div>
              </div>
            </ng-container>



          </div>

          <!-- Faktura korygująca -->
          <div class="mt-2 controls-container bg-neutral-100 dark:bg-slate-900"
            *ngIf="document.id == 'FakturaKorygujaca' || document.id == 'FakturaKorygujacaZaliczkowa' || document.id == 'FakturaKorygujacaRozliczeniowa'">
            <div class="font-medium text-base">Korygowany dokument</div>

            <button *ngIf="invoice.correctedInvoice == null" mat-button class="text-md p-0" color="primary"
              (click)="showSelectCorrectedInvoiceDialog()">
              <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
              <span class="ml-2">Wybierz dokument</span>
            </button>

            <div class="  flex items-center" *ngIf="invoice.correctedInvoice != null">
              {{invoice.correctedInvoice.invoiceName}}

              <button color="warn" matTooltip="Kliknij, aby usunąć korygowany dokument" mat-button class="text-md"
                (click)="invoice.removeCorrectedInvoice()">
                Usuń
              </button>

            </div>
            
            <!-- Przyczyna korekty -->
            <div class="mt-4" *ngIf="invoice.correctedInvoice != null">
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Przyczyna korekty</mat-label>
                <textarea matInput 
                          [value]="invoice.correctionReason" 
                          (change)="invoice.set('correctionReason', $event.target.value);"
                          placeholder="np. Błąd w cenie, zmiana ilości, korekta danych nabywcy..."
                          rows="2"
                          maxlength="500"></textarea>
                <mat-hint>Opcjonalne. Będzie widoczna na PDF i wysłana do KSeF.</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- Faktura końcowa -->
          <div class="mt-2 controls-container bg-neutral-100 dark:bg-slate-900" *ngIf="document.id == 'FakturaKoncowa'">

            <div class="font-medium text-base">
              Powiązane faktury zaliczkowe
              <small class="text-secondary"
                *ngIf="invoice.prepayments.length > 0">({{invoice.prepayments.length}})</small>
            </div>

            <button mat-button class="text-md p-0" color="primary" (click)="showSelectPrepaymentDialog()">
              <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:plus'"></mat-icon>
              <span class="ml-2">Dodaj dokument </span>
            </button>

            <div *ngIf="invoice.prepayments.length > 0">
              <div class="flex items-center" *ngFor="let prepayment of invoice.prepayments; let i = index">
                {{prepayment.invoiceName}}
                <button color="warn" matTooltip="Kliknij, aby usunąc fakturę z tego dokumentu" mat-button
                  class="text-md" (click)="invoice.removePrepayment(i)">
                  Usuń
                </button>
              </div>
            </div>

          </div>

          <!-- Payments -->
          <div data-tour-id="platnosci">
            <!-- Płatność -->
            <div class="controls-container bg-neutral-100 dark:bg-slate-900 grid grid-cols-2 gap-2 mt-3">

              <!-- Przełącznik pokazywania sekcji płatności -->
              <div class="col-span-2 flex items-center justify-between">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Sekcja płatności</span>
                <button mat-button class="text-primary text-sm"
                  (click)="toggleShowPaymentSection()">
                  {{ invoice.showPaymentSection !== false ? 'Ukryj sekcję płatność' : 'Pokaż sekcję płatność' }}
                </button>
              </div>

              <ng-container *ngIf="invoice.showPaymentSection !== false">

              <div class="col-span-2 md:col-span-1">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Status płatności</mat-label>
                  <mat-select [value]="invoice.paymentStatus.value" (valueChange)="onPaymentStatusChange($event)">
                    <mat-option [value]="1">Do zapłaty</mat-option>
                    <mat-option [value]="0">Zapłacono</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Termin płatności - pokazuj gdy status = Do zapłaty (1) -->
              <div class="col-span-2 md:col-span-1" *ngIf="invoice.paymentStatus.value === 1">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Termin zapłaty</mat-label>
                  <input matInput [value]="invoice.paymentDeadline.value" (click)="paymentDeadlinePicker.open()"
                    (dateChange)="onPaymentDeadlineChange($event.target.value)" [matDatepicker]="paymentDeadlinePicker">
                  <mat-datepicker-toggle matIconSuffix [for]="paymentDeadlinePicker">
                    <mat-icon matDatepickerToggleIcon [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #paymentDeadlinePicker></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Data otrzymania zapłaty - pokazuj gdy status = Zapłacono (0) -->
              <div class="col-span-2 md:col-span-1" *ngIf="invoice.paymentStatus.value === 0">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label (click)="$event.preventDefault(); $event.stopPropagation()"
                    class="flex items-center cursor-pointer pb-2" [matMenuTriggerFor]="paymentReceivedDateMenu">
                    {{invoice.additionalPaymentDateHeader.text || 'Data otrzymania zapłaty'}}
                    <mat-icon class="icon-size-4" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
                  </mat-label>
                  <input matInput [value]="invoice.additionalPaymentDateHeader.value" (click)="paymentReceivedPicker.open()"
                    (dateChange)="onAdditionalPaymentDateChange($event.target.value)"
                    [matDatepicker]="paymentReceivedPicker">
                  <mat-datepicker-toggle matIconSuffix [for]="paymentReceivedPicker">
                    <mat-icon matDatepickerToggleIcon [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #paymentReceivedPicker></mat-datepicker>
                </mat-form-field>

                <mat-menu #paymentReceivedDateMenu="matMenu" panelClass="issue-scroll-menu">
                  <div class="px-4 pb-2 text-center text-sm border-b">Wybierz wyświetlaną nazwę</div>
                  <button mat-menu-item (click)="invoice.setAdditionalPaymentDateHeader(header)"
                    *ngFor="let header of paymentDateHeaders">{{header}}</button>
                </mat-menu>
              </div>

              <div class="col-span-2">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Sposób płatności</mat-label>
                  <mat-select [value]="invoice.paymentMethod.value" (valueChange)="onPaymentMethodChange($event)">
                    <mat-option *ngFor="let payment of paymentMethods"
                      [value]="payment.index">{{payment.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-span-2">
                <a class="cursor-pointer mt-2 text-sm text-primary inline-flex items-center" *ngIf="!invoice.bankAccountNumber.show"
                  (click)="invoice.setShowBankAccountNumber(true)">
                  <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:plus'"></mat-icon>
                  Dodaj numer konta
                </a>

                <mat-form-field class="w-full" *ngIf="invoice.bankAccountNumber.show && bankAccounts.length > 0"
                  subscriptSizing="dynamic">
                  <mat-label class="flex justify-between">Numer konta bankowego <small
                      class="cursor-pointer text-sm text-primary"
                      matTooltip="Kliknij, aby nie wyświetlać numeru konta bankowego na fakturze."
                      (click)="invoice.setShowBankAccountNumber(false)">ukryj</small></mat-label>
                  <mat-select [value]="invoice.bankAccountNumber.value"
                    (valueChange)="onBankAccountChange($event)">
                    <mat-option [value]="bankAccount.accountNumber" *ngFor="let bankAccount of bankAccounts">
                      {{bankAccount.bank}}:
                      {{bankAccount.accountNumber}}
                      <span *ngIf="bankAccount.isVATAccount" class="text-xs text-primary ml-1">(VAT)</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full" *ngIf="invoice.bankAccountNumber.show && bankAccounts.length == 0"
                  subscriptSizing="dynamic">
                  <mat-label class="flex justify-between">Numer konta bankowego <small
                      class="cursor-pointer text-sm text-primary"
                      matTooltip="Kliknij, aby nie wyświetlać numeru konta bankowego na fakturze."
                      (click)="invoice.setShowBankAccountNumber(false)">ukryj</small></mat-label>
                  <input matInput bankAccountFormat [value]="invoice.bankAccountNumber.value"
                    (input)="invoice.setBankAccountNumber($event.target.value);" />
                </mat-form-field>

              </div>

              <!-- Dodatkowe konta bankowe -->
              <div class="col-span-2" *ngIf="invoice.bankAccountNumber.show && bankAccounts.length > 1">
                <div *ngFor="let additionalAccount of invoice.additionalBankAccounts; let i = index" class="flex items-center gap-2 mb-2">
                  <mat-form-field class="flex-grow" subscriptSizing="dynamic">
                    <mat-label>{{getBankNameByAccountNumber(additionalAccount.value) || 'Konto ' + (i + 2)}}</mat-label>
                    <mat-select [value]="additionalAccount.value" (valueChange)="onAdditionalBankAccountChange(i, $event)">
                      <mat-option [value]="null" class="text-gray-500">
                        <mat-icon [svgIcon]="'heroicons_outline:eye-slash'" class="mr-2 text-gray-400"></mat-icon>
                        Ukryj to konto z dokumentu
                      </mat-option>
                      <mat-option [value]="bankAccount.accountNumber" *ngFor="let bankAccount of getAvailableBankAccountsForAdditional(i)">
                        {{bankAccount.bank}}: {{bankAccount.accountNumber}}
                        <span *ngIf="bankAccount.isVATAccount" class="text-xs text-primary ml-1">(VAT)</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                
                <a class="cursor-pointer text-sm text-primary"
                   *ngIf="getAvailableBankAccountsForNew().length > 0"
                   (click)="addAdditionalBankAccount()">
                  Dodaj kolejne konto bankowe
                </a>
              </div>

              <!-- Vat account number -->
              <div class="col-span-2" *ngIf="document.config.hasVATAccount">

                <mat-form-field class="w-full" *ngIf="bankAccounts.length > 0" subscriptSizing="dynamic">
                  <mat-label>Konto VAT</mat-label>
                  <mat-select [value]="invoice.vatAccountNumber" (valueChange)="onVatAccountChange($event)">
                    <mat-option [value]="bankAccount.accountNumber" *ngFor="let bankAccount of bankAccounts">
                      {{bankAccount.bank}}:
                      {{bankAccount.accountNumber}}
                      <span *ngIf="bankAccount.isVATAccount" class="text-xs text-green-600 ml-1">(VAT)</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="w-full" *ngIf="bankAccounts.length == 0" subscriptSizing="dynamic">
                  <mat-label>Konto VAT</mat-label>
                  <input matInput bankAccountFormat [value]="invoice.vatAccountNumber"
                    (input)="invoice.setVatAccountNumber($event.target.value);" />
                </mat-form-field>

              </div>

              <!-- Payment description -->
              <div class="col-span-2" *ngIf="invoice.hasPaymentDescription">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Opis płatności</mat-label>
                  <textarea matInput cols="30" rows="2" [value]="invoice.paymentDescription"
                    placeholder="Dodaj opis płatności"
                    (change)="invoice.set('paymentDescription', $event.target.value);"></textarea>
                </mat-form-field>
              </div>

              </ng-container>

              <div class="col-span-2" *ngIf="invoice.hasComments">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Uwagi</mat-label>
                  <textarea matInput cols="30" rows="2" [value]="invoice.comments" placeholder="Dodaj uwagi"
                    (change)="invoice.set('comments', $event.target.value);"></textarea>
                </mat-form-field>
              </div>

            </div>
          </div>

        </div>

        <!-- Right form side -->
        <div class="mt-3 md:mt-0 md:w-80 md:max-w-80 md:ml-auto">
          <div class="controls-container bg-neutral-100 dark:bg-slate-900 " data-tour-id="daty-waluta">

            <div class="grid grid-cols-1 gap-2">

              <!-- Place of issue -->
              <div *ngIf="generalFieldsToShow.has('issuePlace')">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Miejsce wystawienia</mat-label>
                  <input matInput [value]="invoice.placeHeader.value"
                    (change)="invoice.setPlaceHeaderValue($event.target.value); ">
                </mat-form-field>
              </div>

              <!-- Date of issue -->
              <div>
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Data wystawienia</mat-label>
                  <input matInput [value]="invoice.issueDateHeader.value" readonly (click)="picker1.open()"
                    (dateChange)="invoice.setIssueDateHeaderValue($event.target.value); checkInvoiceName(); checkExchangeRate()"
                    [matDatepicker]="picker1">
                  <mat-datepicker-toggle matIconSuffix [for]="picker1">
                    <mat-icon matDatepickerToggleIcon [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>

              <!-- Sub header date (sale date) - ukryj dla faktury zaliczkowej -->
              <div class="relative" *ngIf="!isAdvancePaymentInvoice">
                <!-- Nagłówek z wyborem nazwy i toggle zakresu -->
                <div class="flex items-center justify-between mb-1">

                  <button mat-button class="!px-2 !min-w-0 -mx-2 font-medium text-gray-700 dark:text-gray-300 flex items-center justify-center" 
                          [matMenuTriggerFor]="subHeaderMenu">
                    <span class="block text-ellipsis text-base whitespace-nowrap max-w-48 overflow-clip leading-normal">{{invoice.subHeader.text}}</span>
                    <mat-icon class="icon-size-4 ml-1" [svgIcon]="'tabler_solid:caret-down'" iconPositionEnd></mat-icon>
                  </button>
                  
                  <button mat-button class="!px-2 !min-w-0 text-primary text-sm"
                          (click)="invoice.setSubHeaderIsRange(!invoice.subHeader.isRange)"
                          [matTooltip]="invoice.subHeader.isRange ? 'Wyłącz zakres dat' : 'Włącz zakres dat'">
                    <span class="truncate">{{invoice.subHeader.isRange ? 'Zakres' : 'Zakres dat'}}</span>
                  </button>
                </div>

                <mat-menu #subHeaderMenu="matMenu" panelClass="issue-scroll-menu">
                  <div class="sticky top-0 z-10 -mt-3 bg-neutral-100 left-0 w-full px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                    Wybierz wyświetlaną nazwę
                  </div>
                  <button *ngFor="let header of subheaderDateHeaders" mat-menu-item
                    (click)="invoice.setSubHeader(header)">
                    <mat-icon *ngIf="invoice.subHeader.text == header" [svgIcon]="'tabler_outline:check'"></mat-icon>
                    {{header}}
                  </button>
                </mat-menu>

                <!-- Pola dat -->
                <div [class]="invoice.subHeader.isRange ? 'grid grid-cols-2 gap-2' : ''">
                  <!-- Data Od (lub pojedyncza data) -->
                  @if (invoice.subHeader.isRange) {
                    <mat-form-field class="w-full" subscriptSizing="dynamic">
                      <mat-label>Od</mat-label>
                      <input matInput [value]="invoice.subHeader.value" (click)="picker2.open()"
                        (dateChange)="invoice.setSubHeaderValue($event.target.value)" [matDatepicker]="picker2">
                      <mat-datepicker-toggle matIconSuffix [for]="picker2">
                        <mat-icon matDatepickerToggleIcon [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  } @else {
                    <mat-form-field class="w-full" subscriptSizing="dynamic">
                      <input matInput [value]="invoice.subHeader.value" (click)="picker2.open()"
                        (dateChange)="invoice.setSubHeaderValue($event.target.value)" [matDatepicker]="picker2">
                      <mat-datepicker-toggle matIconSuffix [for]="picker2">
                        <mat-icon matDatepickerToggleIcon [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  }

                  <!-- Data Do (tylko gdy zakres włączony) -->
                  <mat-form-field *ngIf="invoice.subHeader.isRange" class="w-full" subscriptSizing="dynamic">
                    <mat-label>Do</mat-label>
                    <input matInput [value]="invoice.subHeader.valueTo" (click)="picker2To.open()"
                      (dateChange)="invoice.setSubHeaderValueTo($event.target.value)" [matDatepicker]="picker2To">
                    <mat-datepicker-toggle matIconSuffix [for]="picker2To">
                      <mat-icon matDatepickerToggleIcon [svgIcon]="'tabler_outline:calendar-event'"></mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker2To></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div>
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Waluta</mat-label>
                  <mat-select [(ngModel)]="invoice.currency" (ngModelChange)="onCurrencyChange($event)" [disabled]="invoice.documentType === 'FakturaKorygujaca' || invoice.documentType === 'FakturaKorygujacaZaliczkowa' || invoice.documentType === 'FakturaKorygujacaRozliczeniowa' || (isAdvancePaymentInvoice && !!selectedOrder) || (isSettlementInvoice && selectedAdvanceInvoices.length > 0)">
                      <mat-option *ngFor="let cur of currencies" [value]="cur.id">{{cur.id}} - {{cur.name}}</mat-option>
                  </mat-select>
                  <mat-hint *ngIf="invoice.documentType === 'FakturaKorygujaca' || invoice.documentType === 'FakturaKorygujacaZaliczkowa' || invoice.documentType === 'FakturaKorygujacaRozliczeniowa'">Waluta pobrana z faktury korygowanej</mat-hint>
                  <mat-hint *ngIf="isAdvancePaymentInvoice && selectedOrder">Waluta pobrana z zamówienia</mat-hint>
                  <mat-hint *ngIf="isSettlementInvoice && selectedAdvanceInvoices.length > 0">Waluta musi być taka sama jak w fakturach zaliczkowych</mat-hint>
                </mat-form-field>
              </div>

              <!-- Currency exchange -->
              <div *ngIf="invoice.currency != 'PLN'">
                <mat-form-field class="w-full" subscriptSizing="dynamic">
                  <mat-label>Kurs {{invoice.currency}}/PLN</mat-label>
                  <input [disabled]="latestExchangeData != null" matInput exchangeRate [value]="invoice.exchangeRate"
                    (key.up)="resetLatestExchangeDate()" (change)="invoice.setExchangeRate($event.target.value);">
                  <mat-hint class="ml-1" *ngIf="latestExchangeData != null">
                    Kurs NBP z dnia: <span class="ml-1">{{latestExchangeData?.date | date: 'dd/MM/YYYY'}}.</span>
                  </mat-hint>

                  <button *ngIf="latestExchangeData != null" mat-icon-button matSuffix (click)="resetExchangeRate()">
                    <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
                  </button>

                  <button *ngIf="latestExchangeData == null" mat-icon-button matSuffix (click)="checkExchangeRate()">
                    <mat-icon [svgIcon]="'tabler_outline:zoom-question'"></mat-icon>
                  </button>
                </mat-form-field>
              </div>

            </div>

          </div>

          <!-- Adnotacje -->
          <app-annotations-card data-tour-id="adnotacje"
            [invoice]="invoice"
            [bankAccounts]="bankAccounts"
            [hasZwVatRate]="hasZwVatRate()"
            [vatExemptionDefaults]="vatExemptionDefaults"
            (annotationsChange)="renderPreview()"
            (selfInvoicingChange)="onSelfInvoicingChange($event)"
            (splitPaymentChange)="onSplitPaymentChange($event)">
          </app-annotations-card>

          <!-- Informacje dodatkowe (sekcja KSeF: FP) -->
          <div class="controls-container bg-neutral-100 dark:bg-slate-900 mt-3">
            <div class="font-medium text-base flex items-center mb-3 pl-[4.5px]">
              Informacje dodatkowe
            </div>
            <div class="annotation-item">
              <mat-checkbox
                color="primary"
                [checked]="invoice.additionalInfo.isInvoiceToReceipt || false"
                (change)="onInvoiceToReceiptChange($event.checked)">
                <span class="font-medium">Faktura do paragonu</span>
                <span class="text-xs text-gray-500 dark:text-gray-400 ml-1">(FP)</span>
              </mat-checkbox>
              <p class="text-xs text-gray-500 dark:text-gray-400 ml-[44px]">
                Faktura do sprzedaży zarejestrowanej na kasie fiskalnej (art. 109 ust. 3d ustawy)
              </p>
            </div>
          </div>

        </div>
      </div>

      <!-- === Sekcja dla FakturaZaliczka - wybór zamówienia === -->
      <div class="mt-6" *ngIf="isAdvancePaymentInvoice">
        <div class="text-xl font-semibold px-2 mb-4">
          Zamówienie
        </div>

        <div class="bg-neutral-100 dark:bg-slate-900 p-4 rounded-xl">
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Wybór zamówienia - styl jak dla faktury korygującej -->
            <div>
              <div class="font-medium text-base mb-2">Powiązane zamówienie</div>

              <button *ngIf="!selectedOrder" mat-button class="text-md p-0" color="primary"
                (click)="showSelectOrderDialog()">
                <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:chevron-right'"></mat-icon>
                <span class="ml-2">Wybierz zamówienie</span>
              </button>

              <div *ngIf="selectedOrder" class="flex items-start gap-3 p-3 bg-white dark:bg-slate-800 rounded-lg border border-neutral-200 dark:border-slate-700">
                <div class="flex-1">
                  <div class="font-medium">{{ selectedOrder.invoiceName || selectedOrder.documentNumber }}</div>
                  <div class="text-sm text-gray-600 dark:text-gray-400">
                    {{ selectedOrder.buyer?.name }}
                    <span *ngIf="selectedOrder.buyer?.nip"> (NIP: {{ selectedOrder.buyer.nip }})</span>
                  </div>
                  <div class="text-sm text-gray-500 mt-1">
                    Wartość: {{ selectedOrder.grossSum | number:'1.2-2' }} {{ selectedOrder.currency || 'PLN' }}
                  </div>
                </div>
                <button color="warn" matTooltip="Usuń powiązane zamówienie" mat-button class="text-md"
                  (click)="removeSelectedOrder()">
                  Usuń
                </button>
              </div>
            </div>

            <!-- Kwota zaliczki - pokazuj tylko gdy wybrano zamówienie -->
            <div *ngIf="selectedOrder">
              <div class="font-medium text-base mb-2">Kwota zaliczki brutto</div>
              <mat-form-field class="w-full" subscriptSizing="dynamic">
                <!-- <mat-label>Kwota zaliczki (brutto)</mat-label> -->
                <input matInput type="number" clearOnFocus
                       [(ngModel)]="advancePaymentAmount"
                       (ngModelChange)="calculateAdvanceBreakdown()"
                       [min]="0.01"
                       [max]="selectedOrder.grossSum || 0"
                       step="0.01" />
                <span matSuffix class="text-neutral-500 me-2">{{ invoice.currency || 'PLN' }}</span>
                <mat-hint>
                  Maksymalnie: {{ selectedOrder.grossSum | number:'1.2-2' }} {{ invoice.currency || 'PLN' }}
                </mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- Tabela rozkładu VAT zaliczki -->
          <div *ngIf="advancePaymentTaxBreakdown.length > 0" class="mt-4">
            <div class="text-sm font-medium mb-2 text-neutral-600 dark:text-neutral-400">
              Rozkład zaliczki wg stawek VAT:
            </div>
            <table class="w-full text-sm border-collapse">
              <thead>
                <tr class="bg-neutral-200 dark:bg-slate-800">
                  <th class="p-2 text-left">Stawka VAT</th>
                  <th class="p-2 text-right">Netto</th>
                  <th class="p-2 text-right">VAT</th>
                  <th class="p-2 text-right">Brutto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of advancePaymentTaxBreakdown" 
                    class="border-b border-neutral-200 dark:border-slate-700">
                  <td class="p-2">{{ getVatRateLabel(row.vatRate) }}</td>
                  <td class="p-2 text-right">{{ row.netValue | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ row.vatValue | number:'1.2-2' }}</td>
                  <td class="p-2 text-right font-medium">{{ row.grossValue | number:'1.2-2' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="font-semibold bg-neutral-200 dark:bg-slate-800">
                  <td class="p-2">Razem</td>
                  <td class="p-2 text-right">{{ advanceNetTotal | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ advanceVatTotal | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ advancePaymentAmount | number:'1.2-2' }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

        </div>
      </div>

      <!-- === Sekcja dla FakturaRozliczeniowa - wybór faktur zaliczkowych === -->
      <div class="mt-6" *ngIf="isSettlementInvoice">
        <div class="text-xl font-semibold px-2 mb-4">
          Rozliczane faktury zaliczkowe
        </div>

        <div class="bg-neutral-100 dark:bg-slate-900 p-4 rounded-xl">
          
          <!-- Przycisk dodawania faktur zaliczkowych -->
          <div class="mb-4">
            <button mat-button class="text-md p-0" color="primary"
              (click)="showSelectAdvanceInvoicesDialog()">
              <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:plus'"></mat-icon>
              <span class="ml-2">Wybierz faktury zaliczkowe</span>
            </button>
          </div>

          <!-- Tabela wybranych faktur zaliczkowych (format KSeF) -->
          <div *ngIf="selectedAdvanceInvoices.length > 0" class="overflow-x-auto">
            <table class="w-full text-sm border-collapse bg-white dark:bg-slate-800 rounded-lg overflow-hidden">
              <thead>
                <tr class="bg-neutral-200 dark:bg-slate-700">
                  <th class="p-3 text-left">Nr faktury zaliczkowej</th>
                  <th class="p-3 text-left">Nr KSeF</th>
                  <th class="p-3 text-right">Kwota brutto</th>
                  <th class="p-3 text-center w-16"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let advInv of selectedAdvanceInvoices" 
                    class="border-b border-neutral-200 dark:border-slate-600">
                  <td class="p-3">
                    <div class="font-medium">{{ advInv.invoiceName || advInv.documentNumber }}</div>
                    <div class="text-xs text-gray-500">{{ advInv.buyer?.name }}</div>
                  </td>
                  <td class="p-3">
                    <span *ngIf="advInv.ksefNumber" class="text-green-600 dark:text-green-400 font-mono text-xs">
                      {{ advInv.ksefNumber }}
                    </span>
                    <span *ngIf="!advInv.ksefNumber" class="text-gray-400">—</span>
                  </td>
                  <td class="p-3 text-right font-medium">
                    {{ advInv.grossSum | number:'1.2-2' }} {{ advInv.currency || 'PLN' }}
                  </td>
                  <td class="p-3 text-center">
                    <button mat-icon-button color="warn" matTooltip="Usuń z listy"
                      (click)="removeAdvanceInvoice(advInv._id)">
                      <mat-icon [svgIcon]="'tabler_outline:trash'" class="icon-size-4"></mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="selectedAdvanceInvoices.length === 0" class="text-gray-500 dark:text-gray-400 text-sm">
            Nie wybrano jeszcze faktur zaliczkowych do rozliczenia.
          </div>

        </div>
      </div>

      <!-- === Sekcja KOR_ZAL - korekta faktury zaliczkowej === -->
      <div class="mt-6" *ngIf="isCorrectionOfAdvancePayment">
        <div class="text-xl font-semibold px-2 mb-4">
          Korekta zaliczki
        </div>

        <div class="bg-neutral-100 dark:bg-slate-900 p-4 rounded-xl space-y-6">

          <!-- Zamówienie PRZED korektą (read-only) -->
          <div>
            <div class="font-medium text-base mb-2">Zamówienie przed korektą</div>
            <div *ngIf="correctionOrderBefore" class="p-3 bg-white dark:bg-slate-800 rounded-lg border border-neutral-200 dark:border-slate-700">
              <div class="text-sm text-gray-600 dark:text-gray-400 mb-2">
                {{ correctionOrderBefore.invoiceName }}
                — wartość: {{ correctionOrderBefore.grossSum | number:'1.2-2' }} {{ invoice.currency || 'PLN' }}
              </div>
              <app-order-products-table
                [products]="correctionOrderBefore.products"
                [viewHeaders]="document.table.viewHeaders"
                [readonly]="true"
                [striped]="true"
                [currency]="invoice.currency || 'PLN'">
              </app-order-products-table>
            </div>

            <div class="mt-2 text-sm">
              <span class="font-medium">Kwota zaliczki przed korektą:</span>
              <span class="ml-2 font-semibold">{{ correctionAdvanceAmountBefore | number:'1.2-2' }} {{ invoice.currency || 'PLN' }}</span>
            </div>
          </div>

          <!-- Kwota zaliczki po korekcie -->
          <div>
            <div>
              <div class="font-medium text-sm mb-1">Kwota zaliczki po korekcie (brutto)</div>
              <mat-form-field style="max-width: 200px;" subscriptSizing="dynamic">
                <input matInput type="number" clearOnFocus
                       [ngModel]="correctionAdvanceAmountAfter"
                       (ngModelChange)="onCorrectionAdvanceAmountAfterChange($event)"
                       [min]="0" [max]="correctionOrderAfterGrossSum || 0" step="0.01" />
                <span matSuffix class="text-neutral-500 me-2">{{ invoice.currency || 'PLN' }}</span>
                <mat-hint>
                  Maksymalnie: {{ correctionOrderAfterGrossSum | number:'1.2-2' }} {{ invoice.currency || 'PLN' }}
                </mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- Rozkład VAT korekty (różnica) -->
          <div *ngIf="correctionAdvanceTaxBreakdown.length > 0">
            <div class="font-medium text-base mb-2">Podsumowanie stawek podatku (różnica)</div>
            <table class="w-full text-sm border-collapse">
              <thead>
                <tr class="bg-neutral-200 dark:bg-slate-800">
                  <th class="p-2 text-left">Stawka VAT</th>
                  <th class="p-2 text-right">Netto</th>
                  <th class="p-2 text-right">VAT</th>
                  <th class="p-2 text-right">Brutto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of correctionAdvanceTaxBreakdown"
                    class="border-b border-neutral-200 dark:border-slate-700">
                  <td class="p-2">{{ getVatRateLabel(row.vatRate) }}</td>
                  <td class="p-2 text-right">{{ row.netValue | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ row.vatValue | number:'1.2-2' }}</td>
                  <td class="p-2 text-right font-medium">{{ row.grossValue | number:'1.2-2' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="font-semibold bg-neutral-200 dark:bg-slate-800">
                  <td class="p-2">Razem</td>
                  <td class="p-2 text-right">{{ correctionAdvanceNetTotal | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ correctionAdvanceVatTotal | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ correctionAdvanceAmountAfter - correctionAdvanceAmountBefore | number:'1.2-2' }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

        </div>
      </div>

      <!-- === Sekcja KOR_ROZ - korekta faktury rozliczeniowej === -->
      <div class="mt-6" *ngIf="isCorrectionOfSettlementInvoice && invoice.correctedInvoice">
        <div class="text-xl font-semibold px-2 mb-4">
          Korekta rozliczenia
        </div>

        <div class="bg-neutral-100 dark:bg-slate-900 p-4 rounded-xl space-y-6">

          <!-- Powiązane faktury zaliczkowe -->
          <div>
            <div class="font-medium text-base mb-2">Powiązane faktury zaliczkowe</div>

            <!-- Przycisk dodawania faktur zaliczkowych -->
            <div class="mb-4">
              <button mat-button class="text-md p-0" color="primary"
                (click)="showSelectAdvanceInvoicesDialogForCorrection()">
                <mat-icon iconPositionEnd [svgIcon]="'tabler_outline:plus'"></mat-icon>
                <span class="ml-2">Wybierz faktury zaliczkowe</span>
              </button>
            </div>

            <!-- Tabela wybranych faktur zaliczkowych -->
            <div *ngIf="correctionLinkedAdvanceInvoices.length > 0" class="overflow-x-auto">
              <table class="w-full text-sm border-collapse bg-white dark:bg-slate-800 rounded-lg overflow-hidden">
                <thead>
                  <tr class="bg-neutral-200 dark:bg-slate-700">
                    <th class="p-3 text-left">Nr faktury zaliczkowej</th>
                    <th class="p-3 text-left">Nr KSeF</th>
                    <th class="p-3 text-right">Kwota brutto</th>
                    <th class="p-3 text-center w-16"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let advInv of correctionLinkedAdvanceInvoices" 
                      class="border-b border-neutral-200 dark:border-slate-600">
                    <td class="p-3">
                      <div class="font-medium">{{ advInv.invoiceName || advInv.documentNumber }}</div>
                      <div class="text-xs text-gray-500">{{ advInv.buyer?.name }}</div>
                    </td>
                    <td class="p-3">
                      <span *ngIf="advInv.ksefNumber" class="text-green-600 dark:text-green-400 font-mono text-xs">
                        {{ advInv.ksefNumber }}
                      </span>
                      <span *ngIf="!advInv.ksefNumber" class="text-gray-400">—</span>
                    </td>
                    <td class="p-3 text-right font-medium">
                      {{ advInv.grossSum | number:'1.2-2' }} {{ advInv.currency || invoice.currency || 'PLN' }}
                    </td>
                    <td class="p-3 text-center">
                      <button mat-icon-button color="warn" matTooltip="Usuń z listy"
                        (click)="removeCorrectionAdvanceInvoice(advInv._id)">
                        <mat-icon [svgIcon]="'tabler_outline:trash'" class="icon-size-4"></mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="correctionLinkedAdvanceInvoices.length === 0" class="text-gray-500 dark:text-gray-400 text-sm">
              Brak powiązanych faktur zaliczkowych.
            </div>
          </div>

          <!-- Kwota pozostała do zapłaty PRZED korektą (read-only) -->
          <div>
            <div class="font-medium text-sm mb-1">Kwota pozostała do zapłaty przed korektą (brutto)</div>
            <div class="text-lg font-semibold">
              {{ correctionSettlementAmountBefore | number:'1.2-2' }} {{ invoice.currency || 'PLN' }}
            </div>
          </div>

          <!-- Kwota pozostała do zapłaty PO korekcie (edytowalna) -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <div class="font-medium text-sm mb-1">Kwota pozostała do zapłaty po korekcie (brutto)</div>
              <mat-form-field class="max-w-48" subscriptSizing="dynamic">
                <input matInput type="number" clearOnFocus
                       [ngModel]="correctionSettlementAmountAfter"
                       (ngModelChange)="onCorrectionSettlementAmountAfterChange($event)"
                       [min]="0"
                       step="0.01" />
                <span matSuffix class="text-neutral-500 me-2">{{ invoice.currency || 'PLN' }}</span>
              </mat-form-field>
            </div>
          </div>

          <!-- Podsumowanie stawek podatku (różnica) -->
          <div *ngIf="groupedCorrectionSettlementBreakdown.length > 0">
            <div class="font-medium text-base mb-2">Podsumowanie stawek podatku (różnica)</div>
            <table class="w-full text-sm border-collapse">
              <thead>
                <tr class="bg-neutral-200 dark:bg-slate-700">
                  <th class="p-2 text-left">Stawka VAT</th>
                  <th class="p-2 text-right">Netto</th>
                  <th class="p-2 text-right">VAT</th>
                  <th class="p-2 text-right">Brutto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of groupedCorrectionSettlementBreakdown" class="border-b border-neutral-200 dark:border-slate-700">
                  <td class="p-2">{{ row.label }}</td>
                  <td class="p-2 text-right">{{ row.netValue | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ row.amountOfVat | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ row.grossValue | number:'1.2-2' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="font-semibold bg-neutral-200 dark:bg-slate-700">
                  <td class="p-2">Razem</td>
                  <td class="p-2 text-right">{{ invoice.netSum | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ invoice.vatSum | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ correctionSettlementAmountAfter - correctionSettlementAmountBefore | number:'1.2-2' }}</td>
                </tr>
              </tfoot>
            </table>
          </div>

        </div>
      </div>

      <div class="mt-6" *ngIf="!isAdvancePaymentInvoice" data-tour-id="pozycje">
        <div class="text-xl font-semibold px-2" *ngIf="document.id != 'FakturaKorygujaca' && document.id != 'FakturaKorygujacaZaliczkowa' && document.id != 'FakturaKorygujacaRozliczeniowa'">
          Pozycje
        </div>
        <div class="text-xl font-semibold px-2" *ngIf="document.id == 'FakturaKorygujaca' || document.id == 'FakturaKorygujacaZaliczkowa' || document.id == 'FakturaKorygujacaRozliczeniowa'">
          Po korekcie
        </div>

        <div class="overflow-x-auto pb-2">

          <div class="product-row px-2">
            <div class="field" *ngFor="let header of document.table.viewHeaders" [class]="header.class">
              <ng-container *ngIf="header.name !== 'netPrice'">{{header.text}}</ng-container>
              <div *ngIf="header.name === 'netPrice'">{{ priceInputMode === 'brutto' ? 'Cena brutto' : 'Cena netto' }}
                <div *ngIf="invoice.hasDiscount" class="text-xs font-normal text-gray-400 dark:text-gray-500 leading-none">przed rabatem</div>
              </div>
            </div>
          </div>

          <div class="products-bg bg-neutral-100 dark:bg-slate-900 p-2 rounded-xl">
            <ng-container *ngFor="let p of invoice.products; let i = index;">
              <div class="product-row flex items-center content-center">

                <ng-container *ngFor="let tableHeader of document.table.viewHeaders">

                  <ng-container *ngIf="tableHeader.name == 'name'">
                    <div class="field xl relative">
                      <input autocomplete="off" [matAutocomplete]="auto" #productName type="text" [value]="p.name"
                        (change)="p.setName($event.target.value)" (input)="findProducts($event.target.value);" />

                      <span (click)="productName.click()" *ngIf="productName.value == ''"
                        class="absolute bottom-1 ms-2 error-text pointer-events-none">Wprowadź nazwę</span>

                      <mat-autocomplete [displayWith]="displayProductNameFn"
                        (optionSelected)="onOptionSelected($event, p )" #auto="matAutocomplete"
                        class="relative pt-0 rounded-xl shadow-xl">
                        <div
                          class="sticky top-0 z-10 -mt-6 mb-6 bg-neutral-200 left-0 px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                          Szukaj produkt
                        </div>
                        @for (product of foundProducts; track product) {
                        <mat-option [value]="product" class="border-b">
                          <div class="text-md font-medium">{{ product.name }}</div>
                          <div class="text-sm">{{product.grossValue}} {{product.currency || 'PLN'}},
                            {{product.quantity}}x, Stawka: {{getVatRateLabel(product.vatRate)}}</div>
                        </mat-option>
                        }

                      </mat-autocomplete>

                    </div>
                  </ng-container>

                  <ng-container *ngIf="tableHeader.name == 'unitOfMeasure'">
                    <div class="field xs">

                      <div
                        class="realtive flex content-between cursor-pointer align-center w-13 items-center bg-card border dark:border-white p-1 pl-2 rounded-md"
                        style="max-height:31px" [matMenuTriggerFor]="unitOfMeasureMenu">
                        <span class="text-clip truncate w-10 text-sm">{{p.unitOfMeasure}}</span>
                        <mat-icon class="w-3" class="icon-size-3" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
                      </div>

                      <mat-menu #unitOfMeasureMenu="matMenu" panelClass="issue-scroll-menu">
                        <div
                          class="sticky top-0 z-10 -mt-3 bg-neutral-200 left-0 w-i px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                          Jednostka miary
                        </div>
                        <button *ngFor="let measurementUnit of measurementUnits" mat-menu-item
                          (click)="p.setUnitOfMeasure(measurementUnit.value)">
                          <mat-icon *ngIf="p.unitOfMeasure == measurementUnit.value"
                            [svgIcon]="'tabler_outline:check'"></mat-icon>
                          {{measurementUnit?.viewValue}}
                        </button>
                      </mat-menu>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tableHeader.name == 'quantity'">
                    <div class="field xs">
                      <input inputmode="numeric" quantity [value]="p.quantity"
                        (change)="p.setQuantity($event.target.value)" />
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tableHeader.name == 'netPrice'">
                    <div class="field md">
                      <!-- Tryb netto: wpisuj cenę netto -->
                      <input *ngIf="priceInputMode === 'netto'" decimalFormatter clearOnFocus inputmode="numeric" step=".01"
                        [class.zero-price-input]="isPositionUnitPriceInvalidForKsef(p)"
                        [value]="p.netPrice.toFixed(2)"
                        (change)="p.setNetPrice($event.target.value);" />
                      <!-- Tryb brutto: wpisuj cenę brutto jednostkową -->
                      <input *ngIf="priceInputMode === 'brutto'" decimalFormatter clearOnFocus inputmode="numeric" step=".01"
                        [class.zero-price-input]="isPositionUnitPriceInvalidForKsef(p)"
                        [value]="p.getGrossPrice().toFixed(2)"
                        (change)="p.setGrossPrice($event.target.value);" />
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tableHeader.name == 'netValue'">
                    <div class="field md text-center">
                      {{toDecimal(p.netValue)}}
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tableHeader.name == 'vatRate'">
                    <div class="field xs">

                      <div
                        class="w-10 truncate flex content-between cursor-pointer align-center items-center  bg-card border dark:border-white p-1 pl-2 rounded-md"
                        style="max-height:31px" [matMenuTriggerFor]="vatRatesMenu">
                        {{getVatRateLabel(p.vatRate)}} <mat-icon class="icon-size-3" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
                      </div>

                      <mat-menu #vatRatesMenu="matMenu" panelClass="issue-scroll-menu">
                        <div
                          class="sticky top-0 z-10 -mt-3 bg-neutral-100 left-0 w-full px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                          Stawka VAT
                        </div>

                        <button *ngFor="let rate of vatRates" mat-menu-item (click)="p.setTax(rate.value)">
                          <mat-icon *ngIf="p.vatRate == rate.value" [svgIcon]="'tabler_outline:check'"></mat-icon>
                          {{rate?.viewValue}}
                        </button>

                        <div class="p-4">
                          Aby wyświetlać inne stawki <br />
                          przejdz do <a routerLink="/konto/ustawienia/stawki-vat">ustawień stawek</a>.
                        </div>
                      </mat-menu>
                    </div>
                  </ng-container>


                  <ng-container *ngIf="tableHeader.name == 'amountOfVat'">
                    <div class="field md text-center">
                      {{toDecimal(p.amountOfVat)}}
                    </div>
                  </ng-container>

                  <ng-container *ngIf="tableHeader.name == 'grossValue'">
                    <div class="field md">
                      <input decimalFormatter clearOnFocus inputmode="numeric" step=".01"
                        [value]="p?.grossValue?.toFixed(2)"
                        [disabled]="!p?.quantity || p.quantity <= 0"
                        [matTooltip]="(!p?.quantity || p.quantity <= 0) ? 'Wartość brutto nie jest edytowalna gdy ilość wynosi 0.' : ''"
                        (change)="p.setGrossValue($event.target.value)" />
                    </div>
                  </ng-container>


                  <ng-container *ngIf="tableHeader.name == 'options'">
                    <div class="field xs items-center text-center justify-self-center self-center place-self-center">

                      <button mat-icon-button (click)="removeProduct(i)" *ngIf="invoice.products.length > 1">
                        <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
                      </button>

                    </div>
                    <!-- [matMenuTriggerFor]="menu"
                    <mat-menu #menu="matMenu" yPosition="above">
                      <button class="px-1 py-0 m-0" mat-menu-item (click)="removeProduct(i)" >
                        <mat-icon color="danger">delete</mat-icon>
                        Usuń
                      </button>
                    </mat-menu> -->
                  </ng-container>


                </ng-container>

              </div>
              <div class="block product-row p-2" *ngIf="p && p._id == null && !dismissedSavePrompts.has(p) && p.grossValue && isNumberGrossValue(p.grossValue) && p.grossValue > 0">
                Czy chcesz zapisać ten produkt? <span class="text-primary cursor-pointer"
                  (click)="saveProduct(p)">Zapisz</span> <span class="text-yellow-500 cursor-pointer ml-2"
                  (click)="dismissSaveProduct(p)">Nie zapisuj</span>
              </div>
              <div *ngIf="invoice.hasGTU || invoice.hasPKWiU || invoice.hasDiscount" class="flex product-row py-2 border-b gap-2 items-start">

                <!-- GTU Menu -->
                <div *ngIf="invoice.hasGTU" class="flex flex-col">
                  <span class="text-xs text-gray-600 dark:text-gray-400 mb-1">GTU</span>
                  <div
                    class="flex content-between cursor-pointer align-center items-center bg-card border dark:border-white p-1 pl-2 pr-2 rounded-md"
                    style="max-height:31px; min-width:80px" [matMenuTriggerFor]="gtuMenu">
                    <span class="text-sm flex-1">{{p.gtu || 'Brak'}}</span>
                    <mat-icon class="icon-size-3" [svgIcon]="'tabler_solid:caret-down'"></mat-icon>
                  </div>

                  <mat-menu #gtuMenu="matMenu" panelClass="issue-scroll-menu">
                    <div
                      class="sticky top-0 z-10 -mt-3 bg-neutral-100 left-0 w-full px-4 pt-2 pb-2 dark:bg-slate-900 text-sm border-b">
                      Kod GTU
                    </div>
                    <button mat-menu-item (click)="p.setGTU('')">
                      <mat-icon *ngIf="p.gtu == ''" [svgIcon]="'tabler_outline:check'"></mat-icon>
                      Brak
                    </button>
                    <button *ngFor="let gtuCode of gtu" mat-menu-item (click)="p.setGTU(gtuCode.id)">
                      <mat-icon *ngIf="p.gtu == gtuCode.id" [svgIcon]="'tabler_outline:check'"></mat-icon>
                      <div>
                        <div class="font-medium">{{gtuCode.id}}</div>
                        <div class="text-xs text-gray-600 dark:text-gray-400">{{gtuCode.text}}</div>
                      </div>
                    </button>
                  </mat-menu>
                </div>

                <!-- PKWiU Input -->
                <div *ngIf="invoice.hasPKWiU" class="flex flex-col">
                  <span class="text-xs text-gray-600 dark:text-gray-400 mb-1">PKWiU</span>
                  <input 
                    type="text" 
                    class="bg-card border dark:border-white p-1 pl-2 pr-2 rounded-md text-sm"
                    style="max-height:31px; min-width:100px"
                    [value]="p.pkwiu || ''"
                    (change)="p.setPKWiU($event.target.value)"
                    placeholder="np. 10.20.10">
                </div>

                <!-- Rabat -->
                <select-dropdown *ngIf="invoice.hasDiscount" [label]="'Rabat %'" [toggleClass]="'no-arrow'" type="input"
                  [selectedOption]="p.discount" (selectionChange)="p.setDiscount($event)"></select-dropdown>

              </div>

              <!-- Ostrzeżenie: cena pozycji wynosi 0 -->
              <div *ngIf="isPositionUnitPriceInvalidForKsef(p)"
                class="zero-price-warning-row my-2 flex items-start gap-2 px-3 py-2 rounded-lg bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-200"
                style="max-width: 400px;">
                <mat-icon class="icon-size-4 flex-shrink-0 mt-0.5 text-amber-600 dark:text-amber-400"
                  [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                <span class="text-xs leading-snug">{{ getInvalidPriceWarning() }}</span>
              </div>
            </ng-container>

          </div>


        </div>

        <button mat-button class="text-primary text-sm mt-2" (click)="addProduct()">
          <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:plus'"></mat-icon>
          <span>Dodaj kolejny produkt</span>
        </button>

        <!-- === Sekcja kwoty pozostałej do zapłaty dla FakturaRozliczeniowa === -->
        <div *ngIf="isSettlementInvoice" class="mt-6 p-4 bg-neutral-100 dark:bg-slate-900 rounded-xl">
          <div class="flex flex-col md:flex-row md:items-center gap-4">
            <div class="flex-1">
              <mat-form-field class="w-full md:w-80" subscriptSizing="dynamic">
                <mat-label>Kwota pozostała do zapłaty</mat-label>
                <input matInput type="number" step="0.01" min="0"
                       [ngModel]="settlementAmount"
                       (ngModelChange)="onSettlementAmountChange($event)">
                <span matTextSuffix class="ml-2">{{ invoice.currency || 'PLN' }}</span>
              </mat-form-field>
              <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Domyślnie suma brutto z pozycji. Możesz zmienić ręcznie.
              </div>
            </div>
            <div *ngIf="isSettlementAmountManual">
              <button mat-button color="primary" (click)="resetSettlementAmount()">
                <mat-icon [svgIcon]="'tabler_outline:refresh'"></mat-icon>
                <span class="ml-1">Resetuj do sumy brutto</span>
              </button>
            </div>
          </div>
          
          <!-- Tabela rozkładu VAT rozliczenia (grupowane wg KSeF) -->
          <div *ngIf="groupedSettlementBreakdown.length > 0" class="mt-4">
            <div class="text-sm font-medium mb-2 text-neutral-600 dark:text-neutral-400">
              Rozkład kwoty pozostałej do zapłaty wg stawek VAT:
            </div>
            <table class="w-full text-sm border-collapse bg-white dark:bg-slate-800 rounded-lg overflow-hidden">
              <thead>
                <tr class="bg-neutral-200 dark:bg-slate-700">
                  <th class="p-2 text-left">Stawka VAT</th>
                  <th class="p-2 text-right">Netto</th>
                  <th class="p-2 text-right">VAT</th>
                  <th class="p-2 text-right">Brutto</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let group of groupedSettlementBreakdown" 
                    class="border-b border-neutral-200 dark:border-slate-600">
                  <td class="p-2">{{ group.label }}</td>
                  <td class="p-2 text-right">{{ group.netValue | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ group.amountOfVat | number:'1.2-2' }}</td>
                  <td class="p-2 text-right font-medium">{{ group.grossValue | number:'1.2-2' }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="font-semibold bg-neutral-200 dark:bg-slate-700">
                  <td class="p-2">Razem</td>
                  <td class="p-2 text-right">{{ invoice.netSum | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ invoice.vatSum | number:'1.2-2' }}</td>
                  <td class="p-2 text-right">{{ settlementAmount | number:'1.2-2' }}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="text-lg text-primary w-auto cursor-pointer ml-2 mt-3" (click)="addProduct()">

        </div>
      </div>

      <div class="mt-2 summary-row">
        <div class="sum-label text-end sum-price-title">
          {{invoice.sum.label}}
          <span class="sum-price">
            {{invoice.sum.value}} <span class="currency">{{invoice.currency}}</span>
            <br />
            <span class="sum-payment-status-text">{{invoice.paymentStatus.text}}</span>
          </span>
        </div>
      </div>

      <!-- HERE i want to have a fixed sticky bottom-10 auto margin to form (centered), button to save -->
      <!-- Sticky Save Button -->
      <div class="sticky-save-button">

        <button [disabled]="processing == true || !isInvoiceNameAvailable" color="primary" mat-flat-button *ngIf="!invoice || !invoice._id"
          (click)="createDocument()">
          <mat-icon *ngIf="processing" class="animate-spin" [svgIcon]="'tabler_outline:loader-2'"></mat-icon>
          <mat-icon *ngIf="!processing" [svgIcon]="'tabler_outline:plus'"></mat-icon>
          <span class="ml-2">Utwórz dokument</span>
        </button>

        <button [disabled]="processing == true || !isInvoiceNameAvailable" color="primary" mat-flat-button *ngIf="invoice && invoice._id"
          (click)="updateDocument()">
          <mat-icon *ngIf="processing" class="animate-spin" [svgIcon]="'tabler_outline:loader-2'"></mat-icon>
          <mat-icon *ngIf="!processing" [svgIcon]="'tabler_outline:check'"></mat-icon>
          <span class="ml-2">Zapisz dokument</span>
        </button>

      </div>
    </div>

    <!-- Preview -->
    <div class="col-span-12 lg:col-span-4 xl:col-span-5 w-full rounded-xl p-4" [style.background-color]="pdfBackgroundColor">
      <div class="relative h-200 lg:h-full transition-opacity duration-300 ease-in-out"
        [class.opacity-0]="isPdfLoaded === null" [class.opacity-100]="isPdfLoaded !== null"
        [ngClass]="{'full-screen-preview' : showingPreview}">

        <div class="preview-backdrop rounded-xl" (click)="togglePreview()"></div>

        <ngx-extended-pdf-viewer *ngIf="dataUrl !== null" [base64Src]="dataUrl" (pdfLoaded)="onPdfLoaded($event)"
          (pagesLoaded)="onPagesLoaded($event)" [forceFullReloadOfJavaScriptCode]="true" [backgroundColor]="pdfBackgroundColor"
          [height]="'100%'" [showToolbar]="false" [showSidebarButton]="false" [showFindButton]="false"
          [showPagingButtons]="false" [showDrawEditor]="false" [showStampEditor]="false" [showTextEditor]="false"
          [showZoomButtons]="false" [showPresentationModeButton]="false" [showOpenFileButton]="false"
          [showPrintButton]="false" [showDownloadButton]="false" [showSecondaryToolbarButton]="false"
          [showHandToolButton]="true" 
          [showSpreadButton]="false" [showPropertiesButton]="false" [zoom]="zoom">
        </ngx-extended-pdf-viewer>

        <div style="position:absolute; top:0;right: 0; padding: 8px;">

          <button class="bg-gray-50 dark:bg-slate-900 opacity-70" mat-icon-button (click)="zoomIn()"
            [matTooltip]="'Powiększ'">
            <mat-icon svgIcon="tabler_outline:zoom-in"></mat-icon>
          </button>
          <button class="bg-gray-50 dark:bg-slate-900 opacity-70" mat-icon-button (click)="zoomOut()"
            [matTooltip]="'Pomniejsz'">
            <mat-icon svgIcon="tabler_outline:zoom-out"></mat-icon>
          </button>

          <button class="bg-gray-50 dark:bg-slate-900 opacity-70" mat-icon-button (click)="togglePreview()"
            [matTooltip]="showingPreview ? 'Zamknij podgląd' : 'Pełny podgląd'">
            <mat-icon *ngIf="!showingPreview" svgIcon="tabler_outline:maximize"></mat-icon>
            <mat-icon *ngIf="showingPreview" svgIcon="tabler_outline:minimize"></mat-icon>
          </button>

        </div>

        <div class="absolute grid place-content-center bottom-4 w-full" *ngIf="showingPreview">
          <button (click)="closePreview()" class="mx-auto w-60" mat-raised-button color="primary"
            [matTooltip]="'Naciśnij klawisz ESCAPE (ESC), aby zamknąc podgląd.'">Zamknij podgląd <span
              class="text-sm text-neutral-50">(esc)</span></button>
        </div>

      </div>
    </div>

  </div>

</div>
